// TODO: refactor this component 
import React, { Component, useEffect } from 'react';
import {Button, Modal, OverlayTrigger, Tooltip, DropdownButton, Dropdown} from 'react-bootstrap';
import { useMsal } from "../Auth/msal-context";
import moment from 'moment';

import Auth from '../Auth/Auth';
// import AdvancedFiltering from '../Components/AdvancedFiltering';
import Cuteness from '../Components/Features/Cuteness';
import UserPreferences from './Features/UserPreferences';
import ReleaseHotfixNotes from '../Components/Features/ReleaseHotfixNotes';
import { FeatureClickTracker, record, recordEventListeners } from '../Helpers/FeatureHelpers';

import PawLogo from '../images/PawLogo.png';
import PawOnly from '../images/PawOnlyLogo.png';

const auth = new Auth();

const MainSearch = (props) => {
    const searchTargets = ['All', 'TFS', 'Jira', 'D365', 'Communities', process.env.REACT_APP_SALESFORCE, process.env.REACT_APP_SALESFORCEKB, process.env.REACT_APP_SALESFORCEHELP];
    
    const [showReleaseHotFixModal, setShowReleaseHotFixModal ] = React.useState(false);
    const [showUserPreferenceModal, setShowUserPreferenceModal] = React.useState(false);
    const [showCutenessModal, setShowCutenessModal ] = React.useState(false);
    
    const [searchCommit, setSearchCommit ] = React.useState(false);
    const [searchTarget, setSearchTarget ] = React.useState(null);

    useEffect(() => {
        recordEventListeners();
        setSearchCommit(props.searchCommit);

        fetch(`${process.env.PUBLIC_URL}/config.json`)
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
            let self = this;
            let config = data.config
            let ReleaseShowDate = moment(config.ShowReleaseModalUntil).format("YYYY-MM-DD");
            if(moment().format("YYYY-MM-DD") <= ReleaseShowDate && localStorage.getItem("stopShowing") === null ){
                setTimeout(function(){
                    localStorage.setItem("stopShowing", 1);
                    setShowReleaseHotFixModal(true);
                },3000)                
            }else if (moment().format("YYYY-MM-DD") > ReleaseShowDate) {
                localStorage.removeItem("stopShowing");
            }
        }).catch((error) => {
            window.apiError(error);
        }); 
    },[]);

    useEffect(() => {
        setSearchCommit(props.searchCommit);
    },[props.searchCommit]);
    
    const handleChange = (e) => {
        props.setmainSearch(e.target.value);
    };

    const search = (e) => {
        e.preventDefault();
        document.getElementById("search-query").blur();
        setSearchCommit(true);
        props.onSearch(props.mainSearch);
    };

    const performTargetChange = (items) => {
        if(props.mainSearch !== ""){
            props.performSearchOnSelectedTarget(props.mainSearch, items);
        }
        setSearchTarget(items); 
        props.updateTarget(items);
    };

    const targetName = (target) => {
        if (target === "DFOnline") {
            return "Online Help";
        } else if (target === process.env.REACT_APP_SALESFORCE) {
            return "Salesforce Cases";
        } else if (target === process.env.REACT_APP_SALESFORCEKB) {
            return "Salesforce SaaS KB";
        } else if (target === process.env.REACT_APP_SALESFORCEHELP) {
            return "Ceridian Salesforce Help";
        } else if (target === "Communities") {
            return "Community Discussions";
        }  
        else {
            return target;
        }
    };

    return (
        <section className={searchCommit ? "search-container align-items-center active" : "search-container align-items-center"}>   
            <a className="search-logo" onClick={() => { setSearchCommit(false); props.revertSearchCommit(); props.setPinning(false) } }><img src={PawLogo} alt="fetch logo - dog pointing to the right"/></a>      
            <img src={PawOnly} alt="fetch logo - dog pointing to the right" style={{
                position: "absolute",
                bottom: "-150px",
                left: "-250px",
                transform: "rotate(45deg) scale(0.8)",
                opacity: "0.2"
            }}></img>   
            <div className="search-bar-container">              
                <div className="search-logo-main" onClick={() => setSearchCommit(false)}>
                </div>     
                <form id="main-search" onSubmit={search}>
                    <input id="search-query" className="main-search" name="mainSearch" value={props.mainSearch} onChange={(e) => handleChange(e)}/>
                    <Button type="submit" className="search-btn" disabled={!props.mainSearch}>
                        <svg width="100%" height="100%" fill="white">
                            <path d="M22.5,17.8a17.969,17.969,0,0,0-2-1.9A16.379,16.379,0,0,0,18,13.8a15.371,15.371,0,0,1-1.9-1.7,8.46,8.46,0,0,0,.6-4.9A8.116,8.116,0,0,0,11,.3a9.777,9.777,0,0,0-6.9.8A7.1,7.1,0,0,0,1.2,3.9,12.338,12.338,0,0,0,0,7.6v.5H0v.4a12.216,12.216,0,0,0,.3,2.6,7.606,7.606,0,0,0,2.5,3.6A9.825,9.825,0,0,0,12.7,16a7.165,7.165,0,0,0,1.5-1.1,7.678,7.678,0,0,1,1.6,1.5,12.667,12.667,0,0,0,1.3,1.1c.2.2.4.3.6.5a11.408,11.408,0,0,1,1.1,1.1,5.845,5.845,0,0,0,1.4,1.3l.4.3.3-.4a14.622,14.622,0,0,1,1.6-1.9l.3-.3Zm-8.873-7.263c-.107.214-.107.32-.214.534-.427.854-.748,1.709-1.5,2.029h0a6.012,6.012,0,0,1-5.233.534H6.579A3.6,3.6,0,0,1,3.909,11.5c-.32-.534-.641-1.175-.854-1.6,0-.534-.107-.961-.107-1.388V7.76c.107-.427.32-.854.427-1.282V6.265A9.354,9.354,0,0,1,5.4,3.7a4.9,4.9,0,0,1,3.631-.854c3.1.32,4.165,1.282,4.806,4.272A5.332,5.332,0,0,1,13.627,10.537Z" transform="translate(0 0.004)"></path>
                        </svg>
                    </Button>
                    <Button className="search-btn microphone" onClick={() => record(this)} value={props.mainSearch} id="speechToText" style={{display : "none"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="white" viewBox="0 0 24 24"><path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"/></svg>
                    </Button>
                    {(props.mainSearch && props.mainSearch.indexOf("-") > -1) && (
                        <div style={{ position: "absolute", display: "inline-block"}}>
                            <OverlayTrigger
                                placement={"bottom"}
                                overlay={
                                <Tooltip id={`tooltip-top`}>
                                    <div style={{textAlign: "left"}}>The " - " operator has two meanings:
                                        <ul>
                                            <li>When wrapped in "" find the word/sentence containing it (eg. "cloud ops - solutions")</li>
                                            <li>When used on its own it omits the word after the - (eg. cloud ops - solutions will search for cloud ops where solutions is not in the sentence)</li>
                                        </ul>
                                    </div>
                                </Tooltip>
                                }
                            >
                                <span><i className="far fa-question-circle tooltip-icon" style={{color: "white"}}></i></span>
                            </OverlayTrigger>
                        </div>                            
                    )}
                </form>
                <div>
                    {localStorage.getItem("Synonyms") === "true" && (
                    <small className="using-synonyms">excluding synonyms</small> 
                    )}
                </div>
            </div>            
            <div className="search-target-container">
                <div className="text-left float-left">
                    {searchTargets.map((item,index) =>   
                        <Button variant="link" key={index} className={searchTarget === item ? "search-target active" : "search-target"} id={`${item}-btn`} onClick={() => performTargetChange(item)}>
                            {targetName(item)}
                        </Button>
                    )}
                </div>
                <div className="text-right float-right fetch-links">     
                    <OverlayTrigger
                        placement={"bottom"}
                        overlay={
                            <Tooltip id={`tooltip-top`}>
                            My Pins
                            </Tooltip>
                        }
                        >
                        <Button variant="link" onClick={() => { props.setPinning(); FeatureClickTracker("Pinning") } }>
                            <i className="fas fa-thumbtack" style={{fontSize: "16px"}}></i>
                        </Button>
                    </OverlayTrigger>

                    <OverlayTrigger
                        placement={"bottom"}
                        overlay={
                            <Tooltip id={`tooltip-top`}>
                            Dose Of Cuteness
                            </Tooltip>
                        }
                        >
                        <Button variant="link" onClick={() => { setShowCutenessModal(true); FeatureClickTracker("Cuteness") } }><img src={PawOnly} style={{ width: "20px", verticalAlign: "baseline"}} alt="open cuteness" /></Button>
                    </OverlayTrigger>

                    <OverlayTrigger
                        placement={"bottom"}
                        overlay={
                            <Tooltip id={`tooltip-top`}>
                            Release Notes
                            </Tooltip>
                        }
                        >
                        <Button variant="link" onClick={() => { setShowReleaseHotFixModal(true); FeatureClickTracker("Release")} }><i className="fas fa-box-open" style={{fontSize: "16px"}}></i></Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement={"bottom"}
                        overlay={
                            <Tooltip id={`tooltip-top`}>
                            Feedback
                            </Tooltip>
                        }
                        >
                        <Button variant="link" className="feedback_btn" onClick={() => { props.showFeedbackModal(); FeatureClickTracker("Feedback")} }><i className="fas fa-comments"></i></Button>
                    </OverlayTrigger>
                
                
                    <DropdownButton
                        alignRight
                        variant="link"
                        title={<i className="fas fa-user"></i>}
                        id="dropdown-menu-align-right"
                        style={{fontSize: "16px"}}
                    >
                        <Dropdown.Item eventKey="1" variant="link" className="user-dropdown-btn" onClick={() => { setShowUserPreferenceModal(true); FeatureClickTracker("DarkMode")} }>User Preferences</Dropdown.Item>
                        <Dropdown.Item eventKey="1" variant="link" className="user-dropdown-btn" onClick={() => { props.FetchTipAvailable(true); FeatureClickTracker("Fetch Tip")} }>Fetch Tips</Dropdown.Item>  
                        <Dropdown.Item eventKey="1" variant="link" className="user-dropdown-btn" onClick={() => { props.runTour(true); FeatureClickTracker("Tour")} }>Tour</Dropdown.Item>                      
                        <Dropdown.Divider />
                        <Dropdown.Item eventKey="2" variant="link" className="user-dropdown-btn" onClick={() => auth.logout()}>Log Out</Dropdown.Item>
                    </DropdownButton>
                </div>                    
            </div>

            <Modal show={showCutenessModal} onHide={() => setShowCutenessModal(false)} dialogClassName="active" animation={false}>
                {showCutenessModal && (
                    <Cuteness /> 
                )}   
            </Modal>

            <Modal show={showReleaseHotFixModal} onHide={() => setShowReleaseHotFixModal(false)} dialogClassName="active" animation={false}>
                <Modal.Header closeButton>
                    Latest Updates from Release Notes
                </Modal.Header>
                {showReleaseHotFixModal && (
                    <ReleaseHotfixNotes /> 
                )}                          
            </Modal>
            
            <Modal size="lg" show={showUserPreferenceModal} centered onHide={() => setShowUserPreferenceModal(false)} dialogClassName="active" animation={false}>
                {showUserPreferenceModal && (
                    <UserPreferences closeModal={() => setShowUserPreferenceModal(false) } />
                )}            
            </Modal>
        </section>
    );
}

export default MainSearch;